<template>
  <v-container class="pt-0">
    <v-layout row>
      <h1>Event Schedule</h1>
      <v-progress-circular class="ml-3" v-if="loadingEvents" indeterminate />
      <v-spacer/>

      <add-event-dialog v-if="isLoggedIn" />
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="mb-3">
        <v-sheet height="700">
          <v-calendar ref="calendar" color="primary" v-model="calStart" :end="calEnd">
            <template slot="day" slot-scope="{date}">
              <template v-for="event in eventsMap[date]">
                <v-menu :key="event.title" v-model="event.open" full-width offset-x>
                  <div v-if="!event.time" slot="activator" v-ripple :class="`event ${event.type.toLowerCase()}`">
                    {{ event.title }}
                  </div>
                  <v-card min-width="350px" flat>
                    <v-toolbar>
                      <v-toolbar-title>{{ event.title }}</v-toolbar-title>

                      <v-spacer/>

                      <div v-if="isLoggedIn">
                        <v-tooltip bottom>
                          <template #activator="data">
                            <router-link :to="{path: `/assignments/${event.id}`}">
                              <v-btn icon v-on="data.on">
                                <v-icon v-if="event.assignments !== null">edit</v-icon>
                                <v-icon v-else>add</v-icon>
                              </v-btn>
                            </router-link>
                          </template>

                          <template v-if="event.assignments !== null">Edit Assignments</template>
                          <template v-else>Add Assignments</template>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template #activator="data">
                            <v-btn icon v-on="data.on" @click="deleteEvent(event)">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>

                          <span>Delete Event</span>
                        </v-tooltip>
                      </div>
                    </v-toolbar>

                    <v-card-title>
                      <span class="ml-2">
                        <template v-for="line in event.details.split('\n')">{{line}}<br/></template>
                      </span>
                    </v-card-title>
                  </v-card>
                </v-menu>
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-btn @click="$refs.calendar.prev()">
        <v-icon left>keyboard_arrow_left</v-icon>
        <span>Previous</span>
      </v-btn>

      <v-spacer/>

      <v-btn @click="$refs.calendar.next()">
        <span>Next</span>
        <v-icon right>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import format from 'date-fns/format';
import AddEventDialog from './AddEventDialog.vue';
import {db} from '../fbConfig';

export default {
  name: 'Calendar',
  components: {AddEventDialog},
  data() {
    return {
      calStart: '',
      calEnd: '',
      loadingEvents: false
    };
  },
  methods: {
    deleteEvent(event) {
      db.collection('Events').doc(event.id).delete()
        .catch(() => console.log('did something bad'));
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    eventsMap() {
      const map = {};
      for (const event of this.$store.state.events) {
        const date = format(event.date.toDate(), 'YYYY-MM-DD');
        (map[date] = map[date] || []).push(event);
      }

      return map;
    }
  },
  created() {
    this.loadingEvents = true;

    db.collection('Events').onSnapshot(res => {
      for (const change of res.docChanges()) {
        // TODO: Handle removed/deleted/changed/whatever
        if (change.type === 'added') {
          this.$store.commit('addEvent', {
            id: change.doc.id,
            ...change.doc.data()
          });
        } else if (change.type === 'removed') {
          this.$store.commit('removeEvent', change.doc.id);
        }
      }

      this.loadingEvents = false;
    });
  }
};
</script>

<style scoped>
  .event {
    border-radius: 5px;
    width: 100%;
    padding: 3px;
    cursor: pointer;
    margin: 2px 0;
  }

  .event.game {
    background-color: #FF5722;
  }

  .event.competition {
    background-color: #009688;
  }

  .event.special {
    background-color: #1E88E5;
  }
</style>
